import {Injectable} from '@angular/core';
import {ApiService} from "../api/api.service";
import {firstValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  constructor(private readonly apiService: ApiService) {
  }

  newWindow(url: string) {
    const screenWidth = window.screen.availWidth;
    const screenHeight = window.screen.availHeight;
    return window.open(url, '_blank', `width=${screenWidth},height=${screenHeight},top=0,left=0`);
  }


  async getCacheUserTool(module: string): Promise<any> {
    return await firstValueFrom(
      this.apiService.get(`cache-user-tool/${module}`)
    );
  }

  async setCacheUserTool(module: string, data: object): Promise<any> {
    return await firstValueFrom(
      this.apiService.post(`cache-user-tool`, {module: module, data: data})
    );
  }

    async removeCacheUserTool(module: string): Promise<any> {
    return await firstValueFrom(
      this.apiService.post(`cache-user-tool/remove`, {module: module})
    );
  }
}
